import { render, staticRenderFns } from "./ChooseLocale.vue?vue&type=template&id=1ff0c67a&scoped=true"
import script from "./ChooseLocale.vue?vue&type=script&lang=js"
export * from "./ChooseLocale.vue?vue&type=script&lang=js"
import style0 from "./ChooseLocale.vue?vue&type=style&index=0&id=1ff0c67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff0c67a",
  null
  
)

export default component.exports